'use client'

import { useTenantContext } from '@/providers/TenantContextProvider'

import type { TenantConfig } from '@/config/tenants/types'

export function useTenant(): TenantConfig {
  const { tenant } = useTenantContext()

  return tenant
}
